<template>
    <section class="blog">
          <!--banana tree-->
      <div class="banana wow fadeIn" id="banana" data-wow-duration=".2s" data-wow-offset="80" data-wow-delay=".5s">
        <div id="bananatree" class="b4">
          <img src="../../img/banana/0.png">
          <!-- <img src="../../img/banana/3.png" class="b3 bb">
          <img src="../../img/banana/2.png" class="b2 bb">
          <img src="../../img/banana/1.png" class="b1 bb"> -->
        </div>
      </div>
      <div class="main wow fadeInUp" data-wow-duration="1s" data-wow-delay="0">
        <div class="txtcontent strip">
          <h2 class="wow1"><img src="../../asset/svg/title/blog1.svg" alt="站在一個立足點"><br class="m_only"><img src="../../asset/svg/title/blog2.svg" alt="小樹終成為大樹" class="secondtxt"></h2>
          <p class="wow2">讓他們從這裡開始，用自己的方式，發展他們美麗的樣子，讓他們在現實世界裡，以自己的美麗，自給自足、自在生活。</p><a href="javascript:void(0)" class="btn wow3" onclick="trackWaitJump('btn_morestories','https://taiwancurio.wordpress.com/')">
            <!--blogicon-->
            <div class="icon"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 41.24 35.64"><title>read</title><path d="M36.64,0H23.83a4.64,4.64,0,0,0-3.2,1.33A4.64,4.64,0,0,0,17.42,0H4.6A4.67,4.67,0,0,0,0,4.6V27.83a4.67,4.67,0,0,0,4.6,4.6H17.42a1.78,1.78,0,0,1,1.8,1.8,1.4,1.4,0,0,0,1.4,1.4,1,1,0,0,0,.41-.07,1.28,1.28,0,0,0,.82-.63,1.25,1.25,0,0,0,.17-.7,1.78,1.78,0,0,1,1.8-1.8H36.64a4.67,4.67,0,0,0,4.6-4.6V4.6A4.67,4.67,0,0,0,36.64,0ZM22,4.6a1.78,1.78,0,0,1,1.8-1.8H36.64a1.78,1.78,0,0,1,1.8,1.8V27.83a1.78,1.78,0,0,1-1.8,1.8H23.83A4.18,4.18,0,0,0,22,30Zm-2.8,0V30a4.18,4.18,0,0,0-1.8-.41H4.6a1.78,1.78,0,0,1-1.8-1.8V4.6A1.78,1.78,0,0,1,4.6,2.8H17.42A1.78,1.78,0,0,1,19.22,4.6Z" /></svg></div><span>瞭解更多多寶故事</span></a>
        </div>
      </div>
    </section>
</template>
<script>
  export default{
    mounted:function(){

        $(window).on('scroll',function(){
          if($('.blog').size()>0){
            var scroll=$(window).scrollTop();
            var W_height=$(window).innerHeight()*.67;
            var blog_top=$('.blog').offset().top-W_height/3;
            var start=blog_top-W_height;
            if(scroll >= start && scroll < blog_top){
                var unit = W_height/4;
                var how_far = blog_top-scroll;
                // scroll/unit
                var which = Math.ceil(how_far/unit);
                $('#bananatree').removeClass().addClass('b'+which);
            }
            
          }
       })
    }
  }
</script>


// WEBPACK FOOTER //
// Blog.vue?0fd189c8